module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsWomen.7d84438.webp";